import { FC, ReactNode } from 'react';
import HeadCell from './components/head-cell/head-cell';
import Pagination from './components/pagination/pagination';
import LinearLoader from '../loaders/linear-loader/linear-loader';
import useUuid from '../../hooks/uuid-hook';
import { IColumn, IPagination, TABLE_SPACING_VARIANT } from './table.types';
import './table.scss';

interface ISort {
    by: string;
    dir: string;
    onSort: (by: string, dir: string) => void;
}

export interface ITableProps {
    columns: IColumn[];
    children: ReactNode;
    pagination?: IPagination;
    sort?: ISort;
    totalResultsTitle?: string;
    isLoading?: boolean;
    selectableRows?: boolean;
    spacingVariant?: TABLE_SPACING_VARIANT;
}

const Table: FC<ITableProps> = ({
    columns,
    pagination,
    totalResultsTitle,
    isLoading,
    sort,
    selectableRows,
    children,
    spacingVariant = TABLE_SPACING_VARIANT.DEFAULT
}) => {
    const wrapperClassName = 'table-grid-wrapper';
    const generatedUniqeClass = useUuid();
    const uniqueWrapperClassName = wrapperClassName + generatedUniqeClass;

    let gridTemplateColumns = '';
    if (selectableRows) {
        gridTemplateColumns += '30px ';
    }
    columns.forEach(({ width }) => {
        gridTemplateColumns += `${width.value}${width.type} `;
    });

    const gridCss = `
        .${uniqueWrapperClassName}>* {
            grid-template-columns: ${gridTemplateColumns};
        }
    `;
    return (
        <div className={`table-grid-layout ${spacingVariant}`}>
            {isLoading && <LinearLoader />}
            <style>
                {gridCss}
            </style>
            <div className={`${uniqueWrapperClassName} ${wrapperClassName}`}>
                <div className="table-row table-row-head">
                    {selectableRows && <span></span>}
                    {columns.map((c, i) => (
                        <HeadCell
                            key={i}
                            sortable={c.sortable}
                            onSort={sort?.onSort}
                            sortBy={c.sortBy}
                            sortedBy={sort?.by}
                            sortedByDir={sort?.dir}
                        >
                            {c.content}
                        </HeadCell>
                    ))}
                </div>
                {children}
            </div>
            {pagination && <Pagination
                perPage={pagination.perPage}
                onSetPage={pagination.onSetPage}
                page={pagination.page}
                total={pagination.total}
                totalResultsTitle={totalResultsTitle ?? ''}
                buttonColor={pagination.buttonColor}
            />}
        </div>
    );
}

export default Table;
